<template>
  <div class="text-xs-center">
    <v-layout row justify-center>
      <v-dialog :value="dialog" persistent max-width="250">
        <v-card id="tranparency">
          <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
          <v-card-text class="center" style="overflow-y: hidden !important;">
            <v-progress-circular :size="170" :width="7" color="primary" indeterminate>
              <div class="center">
                <img src="static/img/line.svg" width="90px" />
                <br>
                <span>Carregando</span>
              </div>
            </v-progress-circular>
            <!--<v-progress-linear-->
            <!--indeterminate-->
            <!--color="white"-->
            <!--class="mb-0"-->
            <!--&gt;</v-progress-linear>-->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'loader',
  computed: {
    dialog () {
      return this.$store.getters[`loader/dialog`] || false
    }
  }
}
</script>

<style scoped>
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#tranparency {
  background-color: rgba(255, 255, 255, 0.9) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PLoader.vue